import axios from "@/lib/request";

// ===== 定制前端 - App列表管理相关接口 =====

// 获取App列表
export const getAppList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取App详情
export const getAppInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存App（新增/编辑）
export const saveApp = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除App
export const deleteApp = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换App状态（启用/禁用）
export const toggleAppStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取机构列表
export const getChannelList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/channel/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== 定制前端 - App设置相关接口 =====

// 获取App版本列表
export const getAppVersionList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/version/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存App版本
export const saveAppVersion = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/version/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取App升级配置
export const getAppUpgradeConfig = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/upgrade/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存App升级配置
export const saveAppUpgradeConfig = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/upgrade/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除App版本
export const deleteAppVersion = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/version/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换App版本状态
export const toggleAppVersionStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/version/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== App升级管理相关接口 =====

// 获取App升级列表
export const getAppUpgradeList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/upgrade/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换App升级状态
export const toggleAppUpgradeStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/upgrade/enable",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存App升级信息
export const saveAppUpgrade = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/upgrade/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== 产品中心产品配置相关接口 =====

// 获取产品详情
export const getProductInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/product/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};



// ===== Banner管理相关接口 =====

// 获取Banner列表
export const getBannerList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/biz/banner/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存Banner
export const saveBanner = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/biz/banner/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除Banner
export const deleteBanner = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/biz/banner/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换Banner状态
export const toggleBannerStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/biz/banner/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== APP启动页管理相关接口 =====

// 获取启动页列表
export const getStartupList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取启动页详情
export const getStartupInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存启动页
export const saveStartup = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除启动页
export const deleteStartup = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换启动页状态
export const toggleStartupStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== APP引导页管理相关接口 =====

// 获取引导页列表
export const getGuideList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取引导页详情
export const getGuideInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存引导页
export const saveGuide = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除引导页
export const deleteGuide = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换引导页状态
export const toggleGuideStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/config/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== 产品中心栏目配置相关接口 =====

// 获取产品栏目列表
export const getProductColumnList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/product/category/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存产品栏目
export const saveProductColumn = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/category/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除产品栏目
export const deleteProductColumn = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/category/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换产品栏目状态
export const toggleProductColumnStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/category/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 产品栏目排序（上移下移）
export const sortProductColumn = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/category/sort",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 批量导入产品栏目
export const importProductColumns = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/product/category/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== 产品中心产品配置相关接口 =====

// 获取产品列表
export const getProductList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/product/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存产品
export const saveProduct = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/product/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除产品
export const deleteProduct = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/product/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换产品状态
export const toggleProductStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/product/disable",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 产品排序（上移下移）
export const sortProduct = (data) => {
  const { action, ...params } = data
  let url = "/v1/admin/cmn/app/product/sort/up"
  
  if (action === 'down') {
    url = "/v1/admin/cmn/app/product/sort/down"
  } else if (action === 'top') {
    url = "/v1/admin/cmn/app/product/sort/top"
  }
  
  return axios.request({
    url,
    method: "post",
    data: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// App精研产品设置
export const saveAppProductIcon = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/product/icon",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 批量导入产品
export const importProducts = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/app/product/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// ===== 短信签名管理相关接口 =====

// 获取短信签名列表
export const getSmsList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/smssignature/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存短信签名
export const saveSms = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/smssignature/save",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除短信签名
export const deleteSms = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/smssignature/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 切换短信签名状态
export const toggleSmsStatus = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/smssignature/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};